import React, { FC, ReactNode, useEffect, useState } from 'react';
import { STORAGE_KEYS } from 'utils/constants';
import { FilterType } from '../../utils/filters';
import FilterList from './filter-list';
type Props = {
  children?: ReactNode;
  filters: FilterType[];
  onFilterClick: (value: FilterType) => void;
  searchValue: string;
};

type BrandNameType = { name: string; id: string };

const BreadCrumbs: FC<Props> = ({ filters, onFilterClick, searchValue }) => {
  const [activeBrands, setActiveBrands] = useState<BrandNameType[]>([]);
  const [headerBrands, setHeaderBrands] = useState<BrandNameType[]>();
  const activeHeaderBrands: any = localStorage.getItem(STORAGE_KEYS.HEADER_BRANDS);
  const [isAllBrands, setIsAllBrands] = useState(false);

  useEffect(() => {
    setIsAllBrands(activeHeaderBrands === 'ALL');
    const names = activeHeaderBrands?.reduce((acc: BrandNameType[], brandId: string) => {
      const brand = headerBrands?.find(({ id }) => id === brandId);
      // active brands will contain all brand name except 'ALL'
      if (brand !== undefined) acc.push({ name: brand.name, id: brand.id });
      return acc;
    }, []);
    setActiveBrands(names);
  }, [activeHeaderBrands]);

  const removeBrand = (brandId: string) => {
    let filtered: any = activeBrands.filter(({ id }) => id !== brandId)?.map(({ id }) => id);
    if (filtered?.length === 0) filtered = ['ALL'];
    setHeaderBrands(filtered);
  };

  return (
    <div className='mb-3'>
      {filters != null && filters.length > 0 && (
        <FilterList filters={filters} onFilterClick={onFilterClick} />
      )}
      <div className='pl-[20px] text-[16px] leading-[25px]'>
        {searchValue !== '' && (
          <p className='text-gray-4 mb-3'>
            Showing search results for
            <span className='text-white'> {`"${searchValue.toUpperCase()}"`}</span>
          </p>
        )}
        {true && (
          <div className='flex items-center'>
            {isAllBrands && (
              <span className='cursor-pointer ml-[12px] rounded-[20px] text-base bg-white px-4 py-1'>
                All brands
              </span>
            )}
            {activeBrands?.map(({ name, id }) => (
              <span
                role='button'
                onClick={() => removeBrand(id)}
                className='cursor-pointer ml-[12px] rounded-[20px] text-base bg-white px-4 py-1'
                key={id}>
                {name}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

BreadCrumbs.displayName = 'BreadCrumbs';

export default BreadCrumbs;
